export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] max-h-[900px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20minimalist%20composition%20with%20soft%20overlapping%20geometric%20shapes%20in%20cream%20beige%20and%20warm%20sand%20tones%2C%20subtle%20product%20photography%20elements%20blended%20organically%2C%20clean%20editorial%20aesthetic%20with%20smooth%20gradients%2C%20soft%20natural%20lighting%20from%20upper%20left%2C%20modern%20commercial%20design%2C%20harmonious%20balanced%20composition%20with%20generous%20negative%20space%2C%20warm%20earthy%20palette%20with%20gentle%20sage%20accents&width=1600&height=900&seq=hero-main-bg-001&orientation=landscape')`,
        }}
      ></div>

      <div className="absolute inset-0 bg-gradient-to-br from-black/20 via-black/10 to-transparent"></div>

      <div className="relative z-10 flex flex-col justify-center h-full w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-background-50 text-xs font-medium">2026 Updated Comparison</span>
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] mb-4 tracking-tight">
            GTBuy
            <br />
            Spreadsheet
          </h1>

          <p className="text-background-50/80 text-sm md:text-base max-w-lg leading-relaxed mb-8 font-light">
            The #1 comparison and automation system for buying agents. Compare GTBuy Spreadsheet,
            Kakobuy Spreadsheet, and Superbuy Spreadsheet with real feature breakdowns, pricing
            insights, and workflow automation analysis.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-center flex items-center justify-center gap-2"
            >
              Compare Tools Now
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
            >
              Start with GTBuy Spreadsheet
            </a>
          </div>

          <p className="mt-6 text-background-50/50 text-xs">
            Used by users optimizing global sourcing workflows and spreadsheet automation systems.
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}